export default "__VITE_ASSET__lHisSuNU__"